import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').controller('ViewSettingsCtrl', ViewSettingsCtrl);

    function ViewSettingsCtrl(ShipperUser, platformSettingsService) {
        var vm = this;

        vm.generalSettingsForm = {};
        vm.GENERAL_SETTINGS = platformSettingsService.GENERAL_SETTINGS;
        vm.submitGeneralSettings = submitGeneralSettings;
        vm.cancelGeneralSettingsForms = cancelGeneralSettingsForms;
        vm.savingFailed = null;
        vm.generalSettings = {};
        vm.originalGeneralSettings = {};

        ShipperUser.getSettings(
            { setting: 'platform' },
            function (res) {
                vm.generalSettings = res;
                vm.originalGeneralSettings = angular.copy(vm.generalSettings);
            },
            function () {
                // TODO error handling
            }
        );

        function submitGeneralSettings(isValid) {
            if (!isValid) {
                return false;
            }

            ShipperUser.saveSettings(
                { setting: 'platform' },
                vm.generalSettings,
                function () {
                    vm.savingFailed = false;
                },
                function () {
                    vm.savingFailed = true;
                }
            );
        }

        function cancelGeneralSettingsForms() {
            vm.generalSettings = angular.copy(vm.originalGeneralSettings);
        }
    }
})();
